export function getEmptyZakazkaForm(overrides = {}) {
  return {
    osloveni: "pan",
    objednavatel: "",
    telefon: "",
    email: "",
    hrbitov: "Český Krumlov",

    cisloHrobu: "",
    oddeleni: "",
    skupina: "",
    majitelHrobuJmeno: "",
    zesnulyPrijmeni: "",
    zesnulyDatumUmrti: "",
    jmenoNaDesce: "",

    planovaneDatum: "",
    poznamka: "",

    sluzby: [],
    items: [],

      balicekTerminy: ["", "", "", "", "", ""],
    balicekSvatky: [],
    balicekNavstevy: [],

    zdroj: "verejny_form",
    kanal: "web",
    stav: "nova",
    createdFromPublicForm: true,

    ...overrides,
  };
}

export function hasPresnaLokace(form) {
  return (
    !!String(form?.cisloHrobu || "").trim() ||
    !!String(form?.oddeleni || "").trim() ||
    !!String(form?.skupina || "").trim() ||
    !!String(form?.lokaceHrobu || "").trim()
  );
}

export function hasNahradniIdentifikace(form) {
  return (
    !!String(form?.majitelHrobuJmeno || "").trim() ||
    !!String(form?.zesnulyPrijmeni || "").trim() ||
    !!String(form?.zesnulyDatumUmrti || "").trim() ||
    !!String(form?.jmenoNaDesce || "").trim() ||
    !!String(form?.identifikaceText || "").trim()
  );
}

export function buildLokalitaHrobuText(form) {
  return [form?.oddeleni, form?.skupina, form?.cisloHrobu]
    .map((x) => String(x || "").trim())
    .filter(Boolean)
    .join(" / ");
}

export function buildIdentifikaceHrobuText(form) {
  return [
    String(form?.majitelHrobuJmeno || "").trim()
      ? `Majitel: ${String(form?.majitelHrobuJmeno || "").trim()}`
      : "",
    (
      String(form?.zesnulyPrijmeni || "").trim() ||
      String(form?.zesnulyDatumUmrti || "").trim()
    )
      ? `Zesnulý: ${[
          String(form?.zesnulyPrijmeni || "").trim(),
          String(form?.zesnulyDatumUmrti || "").trim(),
        ].filter(Boolean).join(" / ")}`
      : "",
    String(form?.jmenoNaDesce || "").trim()
      ? `Deska: ${String(form?.jmenoNaDesce || "").trim()}`
      : "",
  ]
    .filter(Boolean)
    .join(" | ");
}

export function hasBalicekSelected(form) {
  return (
    String(form?.hlavniSluzba || "").trim() === "balicek_4_plus_1" ||
    (
      Array.isArray(form?.sluzby) &&
      form.sluzby.includes("Základní péče o hrob – 4 návštěvy + 5. zdarma")
    )
  );
}

export function getBalicekDates(form) {
  return (Array.isArray(form?.balicekTerminy) ? form.balicekTerminy : [])
    .map((x) => String(x || "").trim())
    .filter(Boolean);
}

export function normalizeBalicekNavstevy(form) {
  const dates = getBalicekDates(form);
  const current = Array.isArray(form?.balicekNavstevy) ? form.balicekNavstevy : [];

  return dates.map((datum, index) => {
    const found = current.find((x) => String(x?.datum || "").slice(0, 10) == datum) || {};
    const kvetinyCastka = Math.round(Number(found?.kvetinyCastka || 0) * 100) / 100;
    const dekoraceCastka = Math.round(Number(found?.dekoraceCastka || 0) * 100) / 100;

    return {
      id: String(found?.id || `balicek-navsteva-${index + 1}`),
      datum,
      poradi: index + 1,
      jeZdarma: index >= 4,
      kvetinyZapnuto: !!found?.kvetinyZapnuto,
      kvetinyCastka,
      dekoraceZapnuto: !!found?.dekoraceZapnuto,
      dekoraceCastka,
    };
  });
}

function getLimitCastka(limitId, vlastniCastka) {
  const own = Number(vlastniCastka || 0);
  if (String(limitId || "") === "vlastni") {
    return Number.isFinite(own) && own > 0 ? own : 0;
  }

  const mapping = {
    bez: 0,
    do_200: 200,
    do_300: 300,
    do_500: 500,
    do_800: 800,
  };

  return Number(mapping[String(limitId || "")] || 0);
}

function buildTerminyPraci(form) {
  const balicekDates = getBalicekDates(form);
  if (balicekDates.length) {
    const navstevy = normalizeBalicekNavstevy(form);

    return navstevy.map((navsteva, index) => {
      const poradi = index + 1;
      const jeZdarma = index >= 4;

      let bonusTyp = "";
      let nazevNavstevy = `Návštěva ${poradi}`;

      if (poradi === 5) {
        bonusTyp = "bonus_zdarma";
        nazevNavstevy = "5. bonusová návštěva zdarma";
      } else if (poradi === 6) {
        bonusTyp = "jmeninova_bonusova";
        nazevNavstevy = "6. jmeninová bonusová návštěva";
      }

      const rezimNavstevy = poradi === 6 ? "lehka_udrzba" : "standard";
      const navrzenePolozky = [];
      if (navsteva.kvetinyZapnuto && Number(navsteva.kvetinyCastka || 0) > 0) navrzenePolozky.push("Květiny");
      if (navsteva.dekoraceZapnuto && Number(navsteva.dekoraceCastka || 0) > 0) navrzenePolozky.push("Dekorace");
      if (poradi === 6 && !navrzenePolozky.length) navrzenePolozky.push("Svíčka");

      return {
        id: `termin-${poradi}`,
        datum: navsteva.datum,
        poradi,
        jeZdarma,
        bonusTyp,
        nazevNavstevy,
        rezimNavstevy,
        navrzenePolozky,
        hlavniSluzba: String(form?.hlavniSluzba || "").trim(),
        typHrobu: String(form?.typHrobu || "").trim(),
        kvetinyLimit: navsteva.kvetinyZapnuto ? "dle_terminu" : "bez",
        dekoraceLimit: navsteva.dekoraceZapnuto ? "dle_terminu" : "bez",
        kvetinyCastka: Math.round(Number(navsteva.kvetinyCastka || 0) * 100) / 100,
        dekoraceCastka: Math.round(Number(navsteva.dekoraceCastka || 0) * 100) / 100,
      };
    });
  }

  if (String(form?.planovaneDatum || "").trim()) {
    return [{
      id: "termin-1",
      datum: String(form.planovaneDatum).slice(0, 10),
      poradi: 1,
      jeZdarma: false,
      bonusTyp: "",
      nazevNavstevy: "Návštěva 1",
      hlavniSluzba: String(form?.hlavniSluzba || "").trim(),
      typHrobu: String(form?.typHrobu || "").trim(),
      kvetinyLimit: String(form?.kvetinyLimit || "bez"),
      dekoraceLimit: String(form?.dekoraceLimit || "bez"),
      kvetinyCastka: getLimitCastka(form?.kvetinyLimit, form?.kvetinyVlastniCastka),
      dekoraceCastka: getLimitCastka(form?.dekoraceLimit, form?.dekoraceVlastniCastka),
    }];
  }

  return [];
}

function computeOrientacniCenaBezDph(form) {
  const zaklad = Number(form?.orientacniCenaBezDph || 0);
  const kvetiny = getLimitCastka(form?.kvetinyLimit, form?.kvetinyVlastniCastka);
  const dekorace = getLimitCastka(form?.dekoraceLimit, form?.dekoraceVlastniCastka);
  return Math.round((zaklad + kvetiny + dekorace) * 100) / 100;
}

export function validatePublicZakazka(form) {
  const errors = [];

  const hasKontakt =
    !!String(form?.telefon || "").trim() ||
    !!String(form?.email || "").trim();

  if (!String(form?.objednavatel || "").trim()) {
    errors.push("Vyplňte jméno a příjmení objednatele.");
  }

  if (!hasKontakt) {
    errors.push("Vyplňte telefon nebo e-mail.");
  }

  if (!hasPresnaLokace(form) && !hasNahradniIdentifikace(form)) {
    errors.push("Vyplňte prosím číslo hrobu nebo údaje pro dohledání hrobu.");
  }

  if (hasBalicekSelected(form)) {
    const balicekDates = getBalicekDates(form);
      if (balicekDates.length < 1 || balicekDates.length > 6) {
        errors.push("U základní péče vyberte 1 až 6 termínů návštěv. 5. a 6. návštěva jsou zdarma.");
    }
  }

  return errors;
}

export function mapSelectedServicesToItems(sluzby = []) {
  return (Array.isArray(sluzby) ? sluzby : []).map((name, index) => ({
    id: `public-${index + 1}-${String(name || "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")}`,
    typ: "manual",
    nazev: String(name || "").trim(),
    mnozstvi: 1,
    cenaBezDph: 0,
    cenaCelkem: 0,
    skupina: "Veřejný formulář",
    cenikId: "",
    zdroj: "verejny_form",
  }));
}

export function buildPublicPlanNavstev(form) {
  const dates = getBalicekDates(form);
  return dates.map((datum, index) => ({
    id: `public-plan-${index + 1}`,
    datumPlan: datum,
    datumSkutecne: "",
    stav: "plan",
    poznamka: "",
  }));
}

export function normalizePublicZakazkaPayload(form) {
  const base = getEmptyZakazkaForm(form || {});
  const rawTypPece = String(base.typPece || "").trim().toLowerCase();
  const hlavniSluzbaId = String(base.hlavniSluzba || "").trim();

  const isBalicek =
    rawTypPece === "balicek" ||
    rawTypPece === "balicek_5_moznosti" ||
    hlavniSluzbaId === "balicek_4_plus_1" ||
    hasBalicekSelected(base);

  const isPredplatne =
    !isBalicek &&
    (
      rawTypPece === "predplatne" ||
      hlavniSluzbaId === "pravidelna_pece"
    );

  const isObnova =
    !isBalicek &&
    !isPredplatne &&
    (
      rawTypPece === "obnova" ||
      hlavniSluzbaId === "obnova_hrobu"
    );

  const isIndividualni =
    !isBalicek &&
    !isPredplatne &&
    !isObnova &&
    (
      rawTypPece === "individualni" ||
      hlavniSluzbaId === "individualni_poptavka"
    );

  const balicekSvatky = Array.isArray(base.balicekSvatky) ? base.balicekSvatky : [];
  const balicekDates = getBalicekDates(base);
  const balicekNavstevy = normalizeBalicekNavstevy(base);

  const extraPoznamka = [
    base.poznamka || "",
    balicekSvatky.length
      ? `Preferované termíny / svátky: ${balicekSvatky.join(", ")}`
      : "",
    balicekDates.length
      ? `Zadané termíny balíčku: ${balicekDates.join(", ")}`
      : "",
  ]
    .filter(Boolean)
    .join("\n");

  const typPeceFinal = isBalicek
    ? "balicek"
    : (isPredplatne
        ? "predplatne"
        : (isObnova
            ? "obnova"
            : (isIndividualni ? "individualni" : "jednorazova")));

  const pocetPredplatne = Number(base.pocetNavstevCelkem || 0);

  return {
    ...base,
    poznamka: extraPoznamka,
    items: [],
    lokaceHrobu: buildLokalitaHrobuText(base),
    identifikaceText: buildIdentifikaceHrobuText(base),
    typPece: typPeceFinal,
    periodicita: isPredplatne ? String(base.periodicita || "rocne") : "",
    pocetNavstevCelkem: isBalicek ? balicekDates.length : (isPredplatne ? pocetPredplatne : 1),
    zbyvaNavstev: isBalicek ? balicekDates.length : (isPredplatne ? pocetPredplatne : 1),
    uctovanyPocetNavstev: isBalicek ? Math.min(balicekDates.length, 4) : (isPredplatne ? pocetPredplatne : 1),
    planNavstev: isPredplatne ? (Array.isArray(base.planNavstev) ? base.planNavstev : []) : [],
    hlavniSluzbaId: String(base.hlavniSluzbaId || "") || (isBalicek ? "public-balicek-4-plus-1" : ""),
    balicekSvatky,
    balicekTerminy: balicekDates,
    balicekNavstevy,
    terminyPraci: buildTerminyPraci({
      ...base,
      balicekTerminy: balicekDates,
      balicekNavstevy,
    }),
  };
}
